export default {
    'budget_line.amount_available':
        'Montant budgété total - montant mandaté - montant des engagements non soldés',
    'budget_line.amount_mandated':
        'Somme des montants C.A. des mandats liés à la ligne budgétaire',
    'budget_line.amount_realized':
        'Somme du montant mandaté et des engagements non soldés liés à la ligne budgétaire',
    'budget_line.percent_mandated':
        'Montant mandaté de la ligne / montant budgété total',
    'budget_line.percent_realized':
        '(montant mandaté de la ligne + montant des engagements non soldés) / montant budgété total',
    'consumption.value':
        "Les valeurs consommées sont liées à des services municipaux, et leur nature dépend de l'activité considérée. Jours d'accueil en crèche, nombre de repas, nombre d'heures etc",
    'engagement.amount_available': "Montant de l'engagement - montant mandaté",
    'engagement.amount_mandated':
        "Somme des montants C.A. des mandats liés à l'engagement",
    'engagement.percent_mandated':
        "Montant mandaté de l'engagement / montant HT de l'engagement",
    'household.average_invoice_amount':
        "Montant moyen par inscription. Montant des factures/nombre d'inscriptions",
    'housing.size_category':
        'Typologie du logement, T1 T2 T3 etc. Réglages disponible dans les correspondances',
    'housing.social_attribution_type':
        'Type de logement social PLAI PLUS etc. Réglages disponible dans les correspondances',
    'intervention.treatment_duration':
        "date de demande d'intervention → date de fermeture d'intervention",
    'invoice_professional.reception_mandate_duration':
        'durée date réception → date de mandat, ne prend pas en compte les factures non mandatées',
    'invoice_professional.treatment_duration':
        "durée date réception → date de mandat, prend la date actuelle si la facture n'est pas encore mandatée",
    'mandate.amount_admin_account':
        'Montant du mandat reporté sur le compte administratif',
    'mandate.amount_with_result':
        'Montant du mandat reporté sur le compte administratif (inclus les montants des chapitres 001 et 002)',
    'market.amount_engaged':
        'Somme des montants C.A. des egagements liés au marché',
    'market.amount_mandated':
        'Somme des montants C.A. des mandats liés au marché',
    'medium.classification':
        "Classification de l'objet, définie dans les correspondances",
    agent: 'Les agents correspondent aux personnes physiques qui ont été payés par la collectivité',
    consumption:
        'Les présences aux activités municipales correspondent à une activité à laquelle un usager était présent ou a été facturé en fonction des règles appliquées par les services',
    medium: 'Médium disponible dans une médiathèque',
    registration:
        "Les inscriptions aux activités municipales sont des actes administratifs effectués par un foyer pour qu'un des membres de ce foyers participe à l'activité en question. La fréquence dépend de la politique de la collectivité",
    special_excluded: 'Exclure le champ des résultats des requêtes',
};
